import * as _ from "lodash";
function getUrl() {
    const loc = window.location;
    return `${loc.protocol}//${loc.hostname}/`;
};

type ServerLocation = "direct" | "test" | "excite" | "local" | "ppx" | "pri" | "img-wiki" | "develop" | "ppe-prod" | "ppx-test" | "demo" | "img-demo";
type LoginServerLocation = "login-img" | "login-img-ppx" | "login-img-test" | "login-img-tempPPX" | "login-img-PPE" | "login-img-PRI" | "img-ad" | "none";
export type LoginServerType = "img" | "oidc-azuread"
interface LoginServer {
    address: string;
    appId: string;
    type: LoginServerType;
}

export default class Config {
    private static instance: Config;
    public static getInstance() {
        if (!this.instance)
            this.instance = new Config();
        return this.instance;
    }   private serverLocation: ServerLocation = "direct";private directCoreServerUrl: string | undefined = "undefined";private loginServerLocation: LoginServerLocation = "none";

    public get baseURL(): string {
        switch (this.serverLocation) {
            case "test":
                return "https://img-test.azurewebsites.net/";
            case "direct":
                return getUrl();
            case "excite":
                return "https://excite.digital/";
            case "local":
                return "http://localhost:58710/";
            case "ppx":
                return "https://ppx-campus.com/";
            case "pri":
                return "https://pri-test.azurewebsites.net/";
            case "img-wiki":
                return "https://wiki.imaginarity.com/";
            case "develop":
                return "https://develop.imaginarity.com/";
            case "ppe-prod":
                return "https://ppe-porsche.com/";
            case "ppx-test":
                return "https://ppx-test.azurewebsites.net/";
            case "demo":
                return "https://demo.imaginarity.com/";
            case "img-demo":
                return "https://img-demo.azurewebsites.net/";

            default:
                return getUrl();
        }
    }

    public get baseURLCore(): string | undefined {
        switch (this.serverLocation) {
            case "test":
                return undefined;
            case "direct":
                return this.directCoreServerUrl;
            case "excite":
                return undefined;
            case "local":
                return "http://localhost:5000/";
            case "ppx":
                return "https://ppx-campus-core-services.azurewebsites.net/";
            case "pri":
                return "https://ppx-pri-core-services.azurewebsites.net/";
            case "img-wiki":
                return undefined;
            case "develop":
                return "https://img-develop-core-services.azurewebsites.net/";
            case "ppe-prod":
                return undefined;
            case "ppx-test":
                return "https://ppx-test-core-services.azurewebsites.net/";
            case "demo":
                return "https://img-demo-core-services.azurewebsites.net/";

            default:
                return undefined;
        }
    }

    public get frontendURL(): string {
        switch (this.serverLocation) {
            case "test":
                return "https://img-test.azurewebsites.net/index.html#";
            case "local":
                return "http://localhost:3001/#";
            default:
                return "https://www.smart-mobility.info/index.html#";
        }
    }

    private get loginServer(): LoginServer | undefined {
        switch (this.loginServerLocation) {
            case "login-img":
                return {
                    address: "https://login.imaginarity.com/",
                    appId: "6e13adeb-a72c-4178-92c1-b40569834aa7",
                    type: "img"
                }
            case "login-img-ppx":
                return {
                    address: "https://login.imaginarity.com/",
                    appId: "b4555ed1-7dff-4c97-aab7-4fbc1d53eab6",
                    type: "img"
                }
            case "login-img-test":
                return {
                    address: "https://login.imaginarity.com/",
                    appId: "0364ca06-66e9-41ae-b2e7-d72cfa6ac859",
                    type: "img"
                }
            case "login-img-tempPPX":
                return {
                    address: "https://login.imaginarity.com/",
                    appId: "a63227c8-cb39-4873-96bd-64bcd3b88834",
                    type: "img"
                }
            case "login-img-PPE":
                return {
                    address: "https://login.imaginarity.com/",
                    appId: "d1fd3ceb-0f43-4d7b-bd6e-5edc3e1e48ca",
                    type: "img"
                }
            case "login-img-PRI":
                return {
                    address: "https://login.imaginarity.com/",
                    appId: "edef183b-64aa-4d32-83af-d076837e152b",
                    type: "img"
                }
            case "img-ad":
                return {
                    address: `${window.location.protocol}//${window.location.host}/api/requestOidcLogin/`,
                    appId: "",
                    type: "oidc-azuread"
                }
            default:
                return undefined;
        }
    }

    public get loginServerAddress() {
        return this.loginServer?.address;
    }

    public get loginAppId() {
        return this.loginServer?.appId;
    }

    public get hasExternalLoginServer(): boolean {
        return this.loginServer !== undefined;
    }

    public get loginServerType() {
        return this.loginServer?.type
    }

    public get debug(): boolean {
        return false;
    }
}

export const languages = ["de-DE", "en-GB", "en-US", "es-ES", "fr-FR", "it-IT", "ja-JP", "ko-KR", "nl-NL", "pt-BR", "zh-CN", "zh-TW", "ru-RU", "pl-PL", "th-TH", "tr-TR"];
export const fromStandardTargetLngsForCreateProjectToExclude = ["pl-PL", "th-TH", "tr-TR"];

export const extendedLanguages: string[] = _.sortBy([...languages, ..._.uniq(_.filter(_.map(languages, l => {
    const s = l.split("-");
    if (s.length < 2)
        return undefined;
    return s[0];
}), f => f !== undefined))], s => s) as string[];


export const routeNames = {
    myhome: "myhome",
    playlist: "playlist",
    faq: "faq",
    wiki: "ppe",
    help: "help",
    cms: "cms",
    cmscontent: "cmscontent",
    chat: "chat",
    user: "user",
    content: "content",
    best: "best",
    quiz: "quiz",
    tube: "tube",
    podcast: "podcast",
    slideshow: "slideshow",
    search: "search",
    scorm: "scorm",
    inbox: "inbox/:id?",
    playlistRoutes: {
        manage: "managePlaylists",
        edit: "editPlaylist/:id?",
        assign: "assignPlaylist/:id?/:tab?",

    },
    cmsRoutes: {
        project: "project/:id?",
        template: "template/:id?",
        templates: "templates",
        roles: "roles",
        role: "role/:groupId?/:id?",
        directory: "directory/:id/:path*",
        translationBatches: "translationBatch/:id/:bId?",
        file: "file/:projectId/:id/:path*",
        archive: "archive/:projectId/:id/:path*",
        archiveFile: "archiveFile/:projectId/:id/:historyEntry/:path*",
        selectWorkflow: "workflows/:groupid?",
        createWorkflow: "workflow/:groupid/:id?",
        manageLocations: "locations",
        manageCategories: "categories",
        editCategory: "category/:groupid?/:id?",
        editLocation: "location/:groupid?/:id?",
    },
    contentRoutes: {
        category: "cat/:catid?/:catid1?/:catid2?/:catid3?/:catid4?/:catid5?",
        article: "art/:id/:catid?/:catid1?/:catid2?/:catid3?/:catid4?/:catid5?"
    },
    bestRoutes: {
        detail: "detail/:id"
    },
    scormRoutes: {
        legals: "legals"
    },
    wikiRoutes: {
        faq: "faq",
        article: "article/:id/:secId?/:colId?",
        category: "category/:id/:sid?",
        translationSend: "translation/send",
        translationImport: "translation/import",
        copyWikiGroup: "copyWikiGroup",
        news: "addNews/:id?",
        editArticle: "edit/:id?",
    },
    chatRoutes: {
        add: "add",
        detail: "in/:id"
    },
    tubeRoutes: {
        category: "cat/:catid?/:catid1?/:catid2?/:catid3?/:catid4?/:catid5?",
        video: "video/:id/:catid?/:catid1?/:catid2?/:catid3?/:catid4?/:catid5?"
    },
    podcastRoutes: {
        category: "cat/:catid?/:catid1?/:catid2?/:catid3?/:catid4?/:catid5?",
        audio: "audio/:id/:catid?/:catid1?/:catid2?/:catid3?/:catid4?/:catid5?"
    },
    slideshowRoutes: {
        category: "cat/:catid?/:catid1?/:catid2?/:catid3?/:catid4?/:catid5?",
    },
    quizRoutes: {
        detail: "detail/:quizId",
        multiPlayergame: "multi/:quizId/:mode?",
        singlePlayergame: "single/:quizId/:mode?",
        joinPlayergame: "join/:gameId",
    },
}

export const globalSettings = {
    showDataPrivacy: false,
    editorToolTipImage: "https://cdn.imaginarity.com/public/pri/priLinkInfo.svg",
    denySwipeOnMobile: true
}

export const moduleBackgrounds = {
    placeHolder: "https://cdn.imaginarity.com/public/images/pagXreduced.svg",
    welcomeRoadBackground: "https://cdn.imaginarity.com/public/thepage/itBg.jpg",
    groupMailsBackground: "https://cdn.imaginarity.com/public/images/pagXreduced.svg",
    academyBackground: "https://cdn.imaginarity.com/public/thepage/Academy.jpg",
    mobileAcademyBackground: "https://cdn.imaginarity.com/public/thepage/pmaBg4.png",
    smicroBackground: "https://cdn.imaginarity.com/public/thepage/itBg.jpg",
    fallBackBackground: "https://cdn.imaginarity.com/public/thepage/Academy.jpg",
    supportBackground: "https://cdn.imaginarity.com/public/images/support.jpg",
}

export const bannerTop = {
    catImage: {
        qAndA: "https://cdn.imaginarity.com/public/projectImages/pagXRedSquare.svg",
        globalSearchResult: "https://cdn.imaginarity.com/public/tube/logopagx.svg",
        wikiCopyGroup: "https://cdn.imaginarity.com/public/projectImages/pagXRedSquare.svg",
        wikiSendTranslation: "https://cdn.imaginarity.com/public/projectImages/pagXRedSquare.svg",
        wikiTranslationImport: "https://cdn.imaginarity.com/public/projectImages/pagXRedSquare.svg",
    },
    rightImage: {
        qAndA: "https://cdn.imaginarity.com/public/projectImages/imgQandAHeaderRight.png",
        globalSearchResult: "https://cdn.imaginarity.com/public/thepage/search_Header_right.png",
    },
    playlist: "https://cdn.imaginarity.com/public/images/playlistNewHeader.jpg",
    wikiArticleAlternative: "https://cdn.imaginarity.com/public/images/PpeArticleDemo.jpg",
    wikiCategoryAlternative: "https://cdn.imaginarity.com/public/images/PpeCategoryDemo.jpg"
}



export const CurrentSettings = {
    showNewGlobalSearchItem: false,                 // Standard: false - Modernised listing of the global entries found
    showInManagePlaylistSwitchIfUserHasAnyRole: false,
    showNewPpeLinkSelection: true,                      // Standard: false - New design for the selection of articles/sections/columns in the wiki
    showNewWikiArticleSection: false,
}
// WHERE c.type = "PlatformFeaturesV2"